import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SlideNavigationService } from './slide-navigation.service';
import { UserDataService } from '../auth/user.data.service';
import { AuthClient } from '../auth/auth.client';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { RestApi } from 'app/auth/rest.api';
import { ConfigActions } from '../core/reducers/config.actions';
import { Subscription } from 'rxjs';
import { menus } from '../core/models/constants';
import { NavigationService } from '../core/services/navigation.service';
import { IAppState } from 'app/IAppState';
import { IConfigState } from 'app/core/typings/IConfigState';
import { AppDataService } from 'app/app.data.service';


@Component({
  selector: 'slide-navigation',
  templateUrl: 'slide-navigation.component.html',
  styleUrls: ['slide-navigation.component.scss']
})
export class SlideNavigationComponent implements OnInit {

  public profile: IUserProfile = {};
  public isAutoLoginAuthentication: boolean;
  public currentEnvironment: string;
  public currentEnvironmentDisplayText: string;
  public menuItems: Array<INavItem>;
  public defaultView: string;
  public iconEnvironment: string;
  public viewConfig: IConfigState;
  public currentViewSubscription: Subscription;
  public mcVersion: string;
  private _currentView: any;
  private _menusSubscription: Subscription;
  private _studioAlertViews = [
    'Security',
    'Ldap',
    'UserGroups',
    'WorkingTimeSchema',
    'Interfaces',
    'Connectors',
    'ECM',
    'Tracing'].map((e => menus[e].title));

  @Output() itemNavigationClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _slideNavigationService: SlideNavigationService,
    private _authClient: AuthClient,
    private _store: Store<IAppState>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _configActions: ConfigActions,
    private _navigationService: NavigationService,
    private _api: RestApi,
    private _appDataService: AppDataService) {
    this._authClient.getAuthenticationTypeResponse().subscribe((data) => {
      this.isAutoLoginAuthentication = data.SubTypeOAuth2Authentication.localeCompare('AutoLogin') === 0 ||
        data.TypeIDPAuthentication.localeCompare('AutoLogin') === 0;
      this.currentEnvironment = sessionStorage.getItem('environmentType');
      if (this.currentEnvironment)
        this.setIcons();
      else
        this.getEnvironment();
    });
    this._api.get('api/version').subscribe((data) => {
      this.mcVersion = data.version;
    });
  };

  getEnvironment() {
    this._appDataService.getCurrentEnvironment().subscribe(environment => {
      sessionStorage.setItem('environmentType', environment.Current);
      this.currentEnvironment = environment.Current;
      this.setIcons();
    });
  }
  setIcons() {
    switch (this.currentEnvironment) {
      case 'Development':
        this.iconEnvironment = 'icon-code';
        this.currentEnvironmentDisplayText = 'GLOBAL.DEVELOPMENT_ENVIRONMENT';
        break;
      case 'Test':
        this.iconEnvironment = 'icon-test';
        this.currentEnvironmentDisplayText = 'GLOBAL.TEST_ENVIRONMENT';
        break;
      case 'Production':
        this.iconEnvironment = 'icon-production';
        this.currentEnvironmentDisplayText = 'GLOBAL.PRODUCTION_ENVIRONMENT';
        break;
      default:
        break;
    }
  }



  ngOnInit() {
    this._store
      .select((s) => s.profile)
      .subscribe((profile: IUserProfile) => {
        this.profile = profile || {};
      });
    this.currentViewSubscription = this._store
      .select((s) => s.config)
      .subscribe((config: IConfigState) => {
        this.viewConfig = config;
      });
    this._router.events
      .subscribe((data) => {
        if (data instanceof RoutesRecognized) {
          if (data.url === '/' && this.defaultView) {
            this.navigateDefaultView();
          } else {
            this._currentView = data.state.root.firstChild.firstChild &&
              data.state.root.firstChild.firstChild.data ? (data.state.root.firstChild.firstChild.data.title as any) : '';
            this._configActions.updateCurrentView(this._currentView);
            this._configActions.updateCurrentMenu(data.state.root.firstChild.routeConfig.path);
          }
        }
      });
    this._menusSubscription = this._navigationService.mainMenuNavItems.subscribe(navItems => {
      if (!this.menuItems || !this.menuItems.length) {
        this.menuItems = navItems;
        if (this.menuItems.length && this.menuItems[0].SubItems.length) {
          this.defaultView = menus[this.menuItems[0].SubItems[0].Name].path;
        }
      }
    });
  }

  ngOnDestroy() {
    if (this._menusSubscription) {
      this._menusSubscription.unsubscribe();
    }

  }

  onClickNavItem(navItem): void {
    navItem.previousNavItem = this._slideNavigationService.currentNavItem ? { ...this._slideNavigationService.currentNavItem } : null;
    this._slideNavigationService.currentNavItem$.next(navItem);
    this._slideNavigationService.currentNavItem = navItem;
    this.itemNavigationClicked.emit();
  }
  logout() {
    this._authClient.logout();
  }

  reloadCurrentView() {
    const currentRoute = this._router.url;
    let parentPath = currentRoute.indexOf('/settings/') > -1 ? 'settings' : 'mc';
    this._router.navigateByUrl(`/${parentPath}/Refresh`, { skipLocationChange: true }).then(() => {
      this._router.navigateByUrl(currentRoute);
    });
  }

  showStudioAlert() {
    return this.currentEnvironment === 'Development' && _.includes(this._studioAlertViews, this.viewConfig.currentView);
  }

  navigateDefaultView() {
    this._router.navigate(['mc', this.defaultView]);
  }
}
